import React from 'react'
import { EmployerRule } from '../../api/employer-rules'
import { Column } from 'react-table'
import { ResourceLinkCell } from '../table/cells'
import Table from '../table'
import { sortByIgnoreCase } from '../../utils/arrays'
import Protected from '../protected/protected'
import { CheckIcon } from '../icons'
import { Icon } from 'react-bulma-components'
import { Employer } from '../../api/organizations'
import { useLocation } from 'react-router-dom'

interface EmployerRulesListProps {
  employerRules: EmployerRule[]
  employer?: Employer
}

const EmployerRulesList: React.FC<EmployerRulesListProps> = ({ employerRules, employer }) => {
  const location = useLocation()
  const basePath = location.pathname.includes('/employers/')
    ? `/employers/${employer?._id}`
    : '/settings'
  const tableColumns = useRulesTableColumns(basePath)

  return (
    <Table
      columns={tableColumns}
      data={sortByIgnoreCase<EmployerRule>(employerRules, 'name')}
      noDataMessage="Aucune Règle employeur à afficher"
    />
  )
}

const useRulesTableColumns = (basePath: string): Column<EmployerRule>[] => {
  return React.useMemo(
    () => [
      {
        Header: 'Nom',
        accessor: 'name',
        Cell: data => (
          <>
            <Protected roles={['superAdmin']}>
              <ResourceLinkCell
                resource={data.row.original}
                path={`${basePath}/employer-rules/`}
                label={data.row.original.name}
              />
            </Protected>
            <Protected roles={['employerMember']}>{data.row.original.name}</Protected>
          </>
        ),
      },
      /*{
        Header: 'Nom court',
        accessor: 'shortName',
      },
      {
        Header: 'Récap.',
        // @ts-expect-error: react-table type
        accessor: 'display.summary',
        Cell: (data: any) => {
          const employerRule = data.row.original as EmployerRule
          if (employerRule.display.summary)
            return (
              <Icon>
                <CheckIcon />
              </Icon>
            )
          return null
        },
      },
      {
        Header: 'Paie',
        // @ts-expect-error: react-table type
        accessor: 'display.payroll',
        Cell: (data: any) => {
          const employerRule = data.row.original as EmployerRule
          if (employerRule.display.payroll)
            return (
              <Icon>
                <CheckIcon />
              </Icon>
            )
          return null
        },
      },*/
    ],
    [basePath],
  )
}

export default EmployerRulesList
